// Generated from backend/web/src/feature-flags/flag-registry.ts by tools/feature-flags/gen.mjs. Do not edit.

export const POSTHOG_FLAG_DEFAULTS: Readonly<Record<string, boolean>> = {
  plc_program_ingestion_enabled: false,
  groq_gpt_oss_20b_enabled: true,
  groq_gpt_oss_120b_enabled: true,
  use_groq_for_chat: true,
  pass_at_k_retry_enabled: false,
  timeseries_llm_detection_enabled: true,
  use_timeseries_chunked_processing: true,
  xlsx_multi_sheet_processing: true,
  heygen_video_enabled: false,
  use_gemini_for_video_call: false,
  use_gladia_for_video_call: false,
  multi_agent_mode_enabled: false,
  web_search_enabled: true,
  data_catalog_rag_fallback_enabled: false,
  semantic_tool_free_fast_path_enabled: true,
  follow_up_detection_enabled: true,
  chat_token_streaming_enabled: true,
  expert_knowledge_enabled: false,
  restrict_upload_to_internal_users: false,
  qwen35_9b_enabled: false,
  kg_agent_enabled: true,
  cerebras_inference_enabled: false,
  formatting_v2: false,
  pnid_trace_signal_path_rule_enabled: false,
  pnid_list_control_loops_on_sheet_enabled: false,
  pnid_list_blocked_in_candidates_enabled: false,
  pnid_connectivity_lineType_enabled: false,
  pnid_auto_inject_control_loop_enabled: false,
  pnid_auto_inject_relief_path_enabled: false,
  jn_translation_enabled: false,
  help_agent_enabled: false,
  use_attendee_for_meeting_bot: false,
  kg_trace_link_enabled: true,
  kg_admin_apply_proposal_enabled: false,
  pnid_low_confidence_review: false,
  sld_parsing_enabled: false,
  explain_video_enabled: false,
}
